module.exports = __webpack_public_path__ + "static/img/10.f2ac2d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/10.png
// module id = /y6n
// module chunks = 2